import { render, staticRenderFns } from "./productdetail-swiper.vue?vue&type=template&id=586bf52a&scoped=true&"
import script from "./productdetail-swiper.vue?vue&type=script&lang=js&"
export * from "./productdetail-swiper.vue?vue&type=script&lang=js&"
import style0 from "./productdetail-swiper.vue?vue&type=style&index=0&id=586bf52a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586bf52a",
  null
  
)

export default component.exports